import { getOrderOutcome } from "../labOrderOutcome";

// Revenue figures on the Revenue & Payments page (cards and trend chart) come from the lab's
// bookings, so they always agree with each other and with Order History.

const PAID_STATUSES = ["paid", "success", "successful", "completed", "captured"];

// A booking counts as revenue once it is paid and was not cancelled or refunded
export const isPaidBooking = (booking: any) =>
  PAID_STATUSES.includes(String(booking?.paymentStatus || "").trim().toLowerCase()) &&
  getOrderOutcome(booking) !== "refund" &&
  getOrderOutcome(booking) !== "cancelled";

// When the booking was made (falls back to its scheduled date, the only date some responses have)
export const getBookingDate = (booking: any) =>
  new Date(booking?.createdAt || booking?.bookingDate || booking?.scheduledDate);

export const getBookingAmount = (booking: any) => Number(booking?.totalAmount) || 0;

export const formatRupees = (value: number) =>
  `₹${value.toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
